<div class="suggestions-wrapper has-pos-abs">
  <div class="title is-flex has-flex-align-center has-flex-content-center">
    <span translate="home-estimator.results-found" [translateParams]="{total: suggestions.length}"></span>
    <span class="close-ic has-pos-abs" (click)="onClose.emit()">
      <i class="material-icons">close</i>
    </span>
  </div>
  <div class="suggestions-box">
    <div class="suggestions">
      <div *ngFor="let suggestion of suggestions" class="suggestion is-flex has-flex-align-center">
        <i class="material-icons">location_on</i>
        <span (click)="onSuggestionClick.emit(suggestion)">
          {{ suggestion.apart_Suite ? (('home-estimator.unit' | translate) + ' ' + suggestion.apart_Suite + ' - ') : '' }} {{ suggestion.street_From }} {{ suggestion.street_Name }}, {{ suggestion.jurisdiction_Descp }} BC
        </span>
      </div>
    </div>
  </div>
</div>
